import { queryOptions } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';

export default function availableLoginsQuery() {
  return queryOptions({
    queryKey: ['available-logins'],
    queryFn: async () => {
      const { data } = await HttpClient.getAvailableLogins();

      return data.logins;
    },
  });
}
